export const CUSTOM_ATTRIBUTE_FORM_FIELD_PREFIX = 'CUSTOM_ATTRIBUTE_PREFIX'
export const DIAGRAM_LICENCE_KEY =
	'288647e1b56149c702d90676423d6bbc5cf07e34c8960ef2050046f1ec5c6d40239be97805c19bc6d3a84efd1f2e908988c73a29c345043eb738d5d813e48ffbb7307ab01c5b148bf75721c1cdfd28a9f52a77f695e120a68d79d8f7e3bad39a09b8f5d41a9a0fa9397b07325361a655b7f8'

export const CA_KEY = 'customAttributes'
